import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RawHtml } from "../../../lib/ReactUtils";
import USER_ACTIONS from "../../UserActions";
import XButton from "./XButton";
import { createUseStyles } from "react-jss";
import { eventTypes } from "../../../lib/analytics";
import { faComment } from "@fortawesome/free-solid-svg-icons";
import { mergeDeepRight } from "ramda";
import widgetIconStyles from "./WidgetIconStyles.js";

const onCloseClick = (setDisplay, sendEvent) => () => {
  setDisplay(false);
  sendEvent(eventTypes.MINIMIZE_WIDGET, {});
};

export default ({
  addUserAction,
  customWidgetImage,
  numberOfUnreadMessages,
  customWidgetStyle,
  allowMinimize,
  sendEvent,
}) => {
  const [displayNotification, setDisplayNotification] = useState();
  const [display, setDisplay] = useState(true);
  const [showMinimizeButton, setShowMinimizeButton] = useState(false);
  const useStyles = createUseStyles((theme) =>
    mergeDeepRight(
      {
        ...widgetIconStyles(theme),
        close: {
          backgroundColor: "white",
          justifyContent: "center",
          position: "absolute",
          top: "-56px",
          right: "-5px",
          height: "27px !important",
          width: "27px",
          borderRadius: "50%",
          border: "solid #ededed 1px",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1) !important",
          opacity: 1,
          transition: "visibility 0s, opacity 2.5s linear",
          animationName: "$slide-up",
          animationDuration: "0.4s",
          animationTimingFunction: "ease",
          "&:hover": { backgroundColor: "rgb(232, 232, 232) !important" },
        },
      },
      customWidgetStyle || {}
    )
  );
  const styles = useStyles();
  useEffect(() => {
    setTimeout(() => setDisplayNotification(styles.unFade), 500);
  }, [styles]);

  useEffect(() => {
    setShowMinimizeButton(false);
    setTimeout(() => setShowMinimizeButton(true), 1000);
  }, [allowMinimize]);

  return (
    display && (
      <>
        {showMinimizeButton && allowMinimize && (
          <XButton
            close={styles.close}
            onCloseClick={onCloseClick(setDisplay, sendEvent)}
            aria-label="Minimize virtual assistant activation button"
            title="Minimize virtual assistant activation button"
          />
        )}
        <button
          onClick={() => addUserAction(USER_ACTIONS.FAB_BUTTON)}
          className={styles.widgetIcon}
        >
          {numberOfUnreadMessages > 0 ? (
            <div
              className={[styles.notificationCircle, displayNotification].join(
                " "
              )}
            >
              <div className={styles.innerText}>{numberOfUnreadMessages}</div>
            </div>
          ) : null}

          {customWidgetImage ? (
            <RawHtml className={styles.innerIcon} tag={"span"}>
              {customWidgetImage}
            </RawHtml>
          ) : (
            <FontAwesomeIcon
              className={styles.innerIcon}
              icon={faComment}
              aria-label="Click to open virtual assistant"
              title="Click to open virtual assistant"
            />
          )}
        </button>
      </>
    )
  );
};
